import { Vehicle } from '../../../models/Vehicle'

export interface VehicleSpecData {

	vehicle: Vehicle,
	quickInfo: QuickVehicleSpec
	fullInfo: FullVehicleSpec
	baseInfo: FullVehicleSpec
	effects: VehicleSpecEffect[]

}

export type VehicleSpecParam = "MASS" | "POWER" | "TOP_SPEED" | "REDLINE" | "GEARS" | "SHIFT_TIME" | "DRAG" | "BRAKE_100" | "HANDBRAKE" | "GRIP_MAX" | "GRIP_SLIDE" | "BRAKE_BALANCE" | "GRIP_BALANCE" | "TURN_RADIUS" | "TURN_STEER_ANGLE" | "YAW_RESPONSE" | "SPRING_RATE" | "RIDE_HEIGHT" | "TRAVEL" | "COG_HEIGHT" | "WEIGHT_DIST" | "BODY_STRENGTH" | "TANK" | "TORQUE"

export interface VehicleSpecEffect {
	effectId: string,
	param: VehicleSpecParam
	value: string,
	positive: boolean
}

export interface QuickVehicleSpec {
	power: number,
	topSpeed: number,
	acceleration: number,
	weight: number,
	brakesPath: number,
	rotationRadius: number,
	driveBias: "FWD" | "RWD" | "AWD"
}

export interface FullVehicleSpec {
	weight: number,
	aerodynamics: number,

	power: number,
	torque: number,
	topSpeed: number,
	redlineSpeed: number,
	gears: number,
	clutchSpeed: number,

	peakBrakes: number,
	brakesBalance: number
	handbrake: number,

	gripPeak: number,
	tractionGrip: number,
	tractionBiasFront: number,

	rotationRadius: number,
	steeringWheelReaction: number,

	suspensionForce: number,
	suspensionRaise: number,
	suspensionUpperLimit: number,

	centreOfMassOffsetZ: number,
	centreOfMassOffsetY: number,
	bodyDamage: number,
	tankVolume: number
}

export const resolveTranslationKeyForValueSignBySpecType = (specParam: VehicleSpecParam) => {
	switch (specParam) {
		case "MASS": return "kg"
		case "POWER": return "horse_powers_shortened"
		case "TOP_SPEED": return "kmh"
		case "HANDBRAKE": return "acceleration_value"

		case "YAW_RESPONSE":
		case "SHIFT_TIME":
		case "REDLINE": return "seconds"

		case "TURN_RADIUS":
		case "BRAKE_100": return "meters_shortened"

		case "GEARS": return "amounts_short"
		case "DRAG": return "aerodynamics_value"
		case "GRIP_MAX": return "g"
		case "GRIP_SLIDE": return "g"
		case "BRAKE_BALANCE": return "%"
		case "GRIP_BALANCE": return "%"
		case "TURN_STEER_ANGLE": return "meters_shortened"
		case "SPRING_RATE": return "hertz"

		case "TRAVEL":
		case "COG_HEIGHT":
		case "RIDE_HEIGHT": return "millimeters_shortened"

		case "WEIGHT_DIST": return "%"
		case "BODY_STRENGTH": return "HP"
		case "TANK": return "liters_shortened"
		case "TORQUE": return "newton_meters_shortened"
	}
}